import { useContext, useState } from 'react';
import { ClientesContext } from '../../../shared/contexts/ClientesContext';
import styles from './PedidoTabelaAdmin.module.css'
import PopUpDetalhesPedido from './PopUpDetalhesPedido'
import { numeroExibicaoPedido } from '../../../shared/utils/pedido';

function PrecoFormatado({ valor, className, centavosClassName }) {
  const [inteiro, centavos] = Number(valor || 0).toFixed(2).split(".");
  return (
    <span className={className}>
      R$ {inteiro}
      <span className={centavosClassName}>,{centavos}</span>
    </span>
  );
}

function PedidoTabelaAdmin({ pedidos }) {
  const { clientes } = useContext(ClientesContext);
  const [viewDetalhes, setViewDetalhes] = useState(false)
  //guarda o id do pedido que foi aberto
  const [pedidoAberto, setpedidoAberto] = useState(null)

  const verDetalhes = (id) => {
    //diz pra entregar o valor atual que tem guardado (anterior)
    setpedidoAberto(anterior => (anterior === id ? null : id))
    console.log("clicou no pedido: ", id)
  }

  
  // Função auxiliar para buscar o nome do cliente
  const getNomeCliente = (id_cliente) => {
    const cliente = clientes.find(c => c.id_cliente === id_cliente);
    return cliente ? cliente.nome : `Cliente ${id_cliente}`;
  };
  return (
    <div className={styles.container}>
      {pedidos.length === 0 ? (
        <p className={styles.msg}>Nenhum pedido encontrado</p>
      ) : (
        <>
          {/* Tabela para Desktop */}
          <div className={styles.tabelaContainer}>
            <table className={styles.tabela}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Cliente</th>
                  <th>Valor Total</th>
                  <th>Data</th>
                  <th>Status</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {pedidos.map((pedido) => (
                  <tr key={pedido.id_pedido} onClick={() => verDetalhes(pedido.id_pedido)}>
                    <td>
                      <span className={styles.pedidoIdTabela}>#{numeroExibicaoPedido(pedido)}</span>
                    </td>
                    <td>
                      <div className={styles.clienteInfo}>
                        <span className={`${styles.clienteNome} ${!pedido.id_cliente ? styles.clienteVazio : ''}`}>
                          {getNomeCliente(pedido.id_cliente)}
                        </span>
                      </div>
                    </td>
                    <td>
                      <PrecoFormatado valor={pedido.total} className={styles.valorTotal} centavosClassName={styles.valorCentavos} />
                    </td>
                    <td>
                      <span className={styles.dataInfo}>
                        {new Date(pedido.data_pedido).toLocaleString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`${styles.statusBadgeTabela} ${
                            pedido.status === "pendente"
                            ? styles.statusPendente
                            : pedido.status === "pronto"
                            ? styles.statusConcluido
                            : pedido.status === "em andamento"
                            ? styles.statusAndamento
                            : pedido.status === "cancelado"
                            ? styles.statusCancelado
                            : pedido.status === "entregue"
                            ? styles.statusEntregue
                            : ''
                        }`}
                      >
                        {pedido.status}
                      </span>
                    </td>
                    <td>
                      <div className={styles.acaoWrapper}>
                        <button className={styles.btnDetalhes} onClick={(e) => { e.stopPropagation(); verDetalhes(pedido.id_pedido); }}>
                          ⋮
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Cards para Mobile */}
          <div className={styles.cardsContainer}>
            {pedidos.map((pedido) => {
              const tempoDecorrido = () => {
                const agora = new Date();
                const dataPedido = new Date(pedido.data_pedido);
                const diff = Math.floor((agora - dataPedido) / (1000 * 60)); // diferença em minutos
                if (diff < 60) return `Há ${diff} min`;
                const horas = Math.floor(diff / 60);
                return `Há ${horas}h ${diff % 60}min`;
              };

              return (
                <div key={pedido.id_pedido} className={styles.pedidoCard} onClick={() => verDetalhes(pedido.id_pedido)}>
                  <div className={styles.cardHeader}>
                    <span className={styles.pedidoId}>Pedido #{numeroExibicaoPedido(pedido)}</span>
                    <span
                      className={`${styles.statusBadge} ${
                        pedido.status === "pendente"
                          ? styles.statusNovo
                          : pedido.status === "em andamento"
                          ? styles.statusPreparando
                          : pedido.status === "pronto"
                          ? styles.statusPronto
                          : pedido.status === "entregue"
                          ? styles.statusEntregue
                          : ''
                      }`}
                    >
                      {pedido.status === "pendente" ? "NOVO" :
                       pedido.status === "em andamento" ? "PREPARANDO" :
                       pedido.status.toUpperCase()}
                    </span>
                  </div>

                  <div className={styles.cardInfo}>
                    <span className={styles.timeInfo}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                        <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                      {tempoDecorrido()}
                    </span>
                    <span className={styles.mesaInfo}>• Cliente {getNomeCliente(pedido.id_cliente)}</span>
                  </div>

                  <div className={styles.cardItems}>
                    {pedido.itens && pedido.itens.slice(0, 3).map((item, index) => (
                      <div key={index} className={styles.itemRow}>
                        <span className={styles.itemQtd}>{item.quantidade}x</span>
                        <span className={styles.itemNome}>{item.nome_produto || 'Item'}</span>
                        <span className={styles.itemPreco}>R$ {Number(item.preco || 0).toFixed(2)}</span>
                      </div>
                    ))}
                  </div>

                  <div className={styles.cardFooter}>
                    <span className={styles.totalLabel}>Total</span>
                    <span className={styles.totalValue}>R$ {Number(pedido.total || 0).toFixed(2)}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* Pop-up renderizado fora dos cards, em nível de página */}
      {pedidoAberto && (
        <PopUpDetalhesPedido
          pedido={pedidos.find(p => p.id_pedido === pedidoAberto)}
          onClose={() => setpedidoAberto(null)}
        />
      )}
    </div>
  )
}

export default PedidoTabelaAdmin;
